import React from 'react'
import { isEmpty } from 'lodash'

import { getPlaceholderContent } from '@/utils/helpers'
import { FormField } from '@/components/forms/FormField'

import { MultiSelect } from '../forms/MultiSelect'

export const MultiFilter = ({ label, accessor, store, handler, ...props }) => {
  return (
    <FormField data-testid={props.dataTestId || `${accessor}-dropdown`}>
      {label && <label>{label}</label>}
      <MultiSelect
        options={store.data[accessor]}
        disabled={store.loading[accessor] || isEmpty(store.data[accessor])}
        loading={store.loading[accessor]}
        value={store.filters[accessor]}
        fixedWidth
        onChange={(value) => {
          if (handler) {
            handler({ [accessor]: value })
          } else {
            props.onChange(value)
          }
        }}
        {...getPlaceholderContent(store.data, store.loading, accessor)}
        {...props}
      />
    </FormField>
  )
}
